import { useEffect } from 'react';

import { types } from './definitions';

const useTabFocus = ({
  isDisabled,
  onTabFocus,
  onTabBlur,
}: types.UseTabFocusArgs): void => {
  const handleTabFocus = (): void => {
    if (onTabFocus) {
      onTabFocus();
    }
  };

  const handleTabBlur = (): void => {
    if (onTabBlur) {
      onTabBlur();
    }
  };

  const handleVisibilityChange = (): void => {
    if (document.hidden) {
      handleTabBlur();
    } else {
      handleTabFocus();
    }
  };

  useEffect(() => {
    if (isDisabled) {
      return;
    }

    // Event listener for refocusing on tab
    window.addEventListener('focus', handleTabFocus, { passive: true });
    // Event listener for moving away from tab
    window.addEventListener('blur', handleTabBlur, { passive: true });
    // Event listener for visibility chang on mobile devices
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return (): void => {
      window.removeEventListener('focus', handleTabFocus);
      window.removeEventListener('blur', handleTabBlur);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isDisabled]);
};

export default useTabFocus;
